var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"delivery-profile__rates"},_vm._l((_vm.zones),function(zone){return _c('DeliveryProfileZone',{key:zone.id,attrs:{"zone":zone},on:{"openShippingZoneModal":zone => _vm.$emit('openShippingZoneModal', zone)}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }